/* eslint-disable react/react-in-jsx-scope */
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const cerebroHomeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'cerebro-home',
      params: {
        path: '/',
        title: 'Home',
        loader: async () => {
          const { DefaultTemplate } = await import('../../home/HomePage');
          return <DefaultTemplate />;
        },
      },
    }),
  ],
});
